import React, { useState }  from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import IconStrip from "../components/IconStrip";
import NavStrip from "../components/NavStrip";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


//import ResidentialSolar from "../pages/ResidentialSolar";//
import "./Home.css"; // Ensure this path is correct for Home's styles
// IMPORTANT: Adjust these paths if your images are in different locations relative to Home.js
import NavbarBackgroundImage from '../images/Nav.png'; // Navbar background image
import sola from '../images/sola.png'; // Hero section background image
import CiImage from '../images/Ci.png'; // Added Ci.png import for the About Us section
import MissionImage from '../images/placeholder.jpg'; // New: Image for the Mission section
import ExpertiseImage from '../images/about.png'; // New: Image for Our Expertise section
import ServiceCardOneImage from '../images/One.png';
import ServiceCardTwoImage from '../images/Two.png';
import ServiceCardThreeImage from '../images/Three.png';
import PartnerImage from '../images/Untitled.jpg';
import solarPanGif from '../images/solar-panel.gif' ;
import Solalogo from "../images/Solalogo.png";
import sola1 from "../images/sola1.jpg";
import sola2 from "../images/sola2.jpg";

function Home() {
   const navigate = useNavigate();
  // Style object for the Navbar's background image
  const navbarBackgroundStyle = {
    backgroundImage: `url(${NavbarBackgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
  };

  // Style object for the Hero Section's background image

   // State to manage whether the additional "Our Expertise" content is shown
    const [showExpertiseDetails, setShowExpertiseDetails] = useState(false);

    // Function to toggle the visibility of the expertise details
    const toggleExpertiseDetails = () => {
        setShowExpertiseDetails(!showExpertiseDetails);
    };

     // --- START: Form state and handlers (MOVED INSIDE Home component) ---
    // State for Contact Form inputs
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically send the form data to a backend server
        console.log('Form submitted:', formData);
        alert('Thank you for your message! We will get back to you soon.');
        // Optionally, clear the form
        setFormData({ name: '', email: '', message: '' });
    };
    // --- END: Form state and handlers --//
    const location = useLocation();

  useEffect(() => {
    // URL me #home-our-services-section ho toh scroll kare
    if (window.location.hash === "#home-our-services-section") {
      const element = document.getElementById("home-our-services-section");
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100); // Thoda delay to ensure DOM fully loaded
      }
    }
  }, [location]);

  const handleScrollToServices = () => {
  const element = document.getElementById("home-our-services-section");
  if (element) element.scrollIntoView({ behavior: "smooth" });
};


  const handleExploreNow = () => {
    navigate("/about-info"); // Navigate to About Information page
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
  };
 
  const [searchQuery, setSearchQuery] = useState(""); // state for search input

  const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
};

const handleLearnMore = () => {
  const query = searchQuery.toLowerCase();

  if (query.includes("services")) {
    const element = document.getElementById("home-our-services-section");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  } else if (query.includes("mission")) {
    const element = document.getElementById("about-us-section");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  } else if (query.includes("expertise")) {
    const element = document.getElementById("home-expertise-section");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  } else if (query.includes("contact")) {
    const element = document.getElementById("contact-us-section");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  } else if (query.includes("residential")) {
    const element = document.getElementById("home-residential-solar-section");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  } else if (query.includes("commercial")) {
    const element = document.getElementById("home-commercial-solar-section");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  } else {
    alert("Sorry, we couldn't find a matching section.");
  }
};

 // ✅ Background slideshow images
  const images = [sola, sola1, sola2];

  const [currentIndex, setCurrentIndex] = useState(0);

  // ✅ Slide change every 4s
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  // Current background style
  const heroSectionStyle = {
    backgroundImage: `url(${images[currentIndex]})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    transition: "background-image 1s ease-in-out", // smooth slide
  };

  return (
    <>
      {/* Navbar Section */}
      
      {/* Hero Section - This will be the first main section on the page */}
      <header className="hero-section" id="home" style={heroSectionStyle}>
        <div className="overlay"></div>
        <div className=" text-white hero-content" style={{ zIndex: 2 }}>
          <div className="logo-left-wrapper">
           <img src={Solalogo} alt="Solaris Logo" className="navbar-logo" />
           </div>
            <h1 className="display-5 fw-bold text-center fade-in-out">
            Raysol Solar Tech Private Limited
            </h1>
          <p className="lead text-center">
            Welcome to our Raysol solar tech private limited website! Discover the power of renewable energy and
            learn how you can transition to a sustainable future.
          </p>
          <button
           className="btn btn-lg px-4 hero-button text-center"
           onClick={() => navigate("/about-info#home-our-services-section")}
>
           Get Started
          </button>

        </div>
      </header>

      {/* --- About Us Section - NEW STRUCTURE --- */}
      <div className="home-about-us-section" id="home-about-us-section" > {/* This is the NEW CONTAINER for the extending white background */}
        {/* Top Bar with "Our", Search Input, and Buttons */}
        <div className="home-about-us-top-bar">
          <span className="home-about-us-our-text">Our</span>
          <div className="home-about-us-search-container">
            <input
            type="text"
            placeholder="Discover our innovative solar solutions"
            className="home-about-us-search-input"
            value={searchQuery}
            onChange={handleSearchChange}
            />
           </div>
             <button
             className="home-about-us-button home-learn-more-btn"
             onClick={handleLearnMore}
              >
             Learn More
            </button>
            <button
            className="home-about-us-button home-contact-us-btn"
            onClick={() => {
            const element = document.getElementById("contact-us-section");
            if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
            >
           Contact Us
          </button>
        </div>
        {/* This wrapper now holds the dark background for the main About Us content */}
     <section className="home-about-us-section-wrapper" id="about-us-section" >
    {/* Main Content Area: Left Text Block & Right Gradient Circle */}
    <div className="home-about-us-main-content">
        <div className="home-about-us-left-content">
            <p className="home-about-us-efficient">Efficient</p>
            <h2 className="home-about-us-reliable">Reliable</h2>
            <p className="home-about-us-description">
                At Raysol Solar tech Private Limited, we are committed to providing our customers
                with the most advanced and reliable solar energy solutions
            </p>
            {/* Explore Now button and Innovative text side-by-side */}
            <div className="home-about-us-button-innovative-row">
              <button 
                 className="home-explore-now-btn" 
                 onClick={handleScrollToServices}
              >
              Explore Now
             </button>
                <p className="home-about-us-innovative">Innovative</p>
            </div>

            {/* UPDATED: Feature Cards Section. The parent div now has the correct class name. */}
            <div className="home-about-us-features-card">
                {/* Design Feature Card */}
                <div className="home-about-us-feature-card">
                    {/* UPDATED: This div groups the icon and text. */}
                    <div className="home-about-us-feature-header">
                        <div className="home-about-us-feature-icon-wrapper">
                            {/* SVG for Design icon */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="home-about-us-feature-icon">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                            </svg>
                        </div>
                        {/* UPDATED: This new div groups the title and subtitle. */}
                        <div className="home-about-us-feature-content">
                            <h3 className="home-about-us-feature-title">Design</h3>
                            <p className="home-about-us-feature-subtitle">Cutting-Edge Technology</p>
                        </div>
                    </div>
                    <p className="home-about-us-feature-description">
                        Our cutting-edge solar technology is<br/>
                        designed to maximize efficiency and<br/>
                        performance
                    </p>
                </div>

                {/* Durable Feature Card */}
                <div className="home-about-us-feature-card">
                    {/* UPDATED: This div groups the icon and text. */}
                    <div className="home-about-us-feature-header">
                        <div className="home-about-us-feature-icon-wrapper">
                            {/* SVG for Durable/Eco-Friendly icon */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="home-about-us-feature-icon">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-8.5"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        {/* UPDATED: This new div groups the title and subtitle. */}
                        <div className="home-about-us-feature-content">
                            <h3 className="home-about-us-feature-title">Durable</h3>
                            <p className="home-about-us-feature-subtitle">Eco-Friendly</p>
                        </div>
                    </div>
                    <p className="home-about-us-feature-description">
                        Reduce your carbon footprint and embrace<br/>  
                         a sustainable future with
                    </p>
                </div>
            </div>
        </div> {/* End of home-about-us-left-content */}

        <div className="home-about-us-right-content">
            {/* Replaced gradient circle with image */}
            <img
                src={CiImage}
                alt="Solar energy illustration"
                className="home-about-us-right-image"
                onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/300x300/2c3e50/ffffff?text=Image+Not+Found'; }}
            />
        </div>
    </div>
  </section> {/* End of home-about-us-section-wrapper */}
      </div> {/* End of white-background-container */}
      {/* --- End of About Us Section --- */}

      {/* --- New: Our Mission Section --- */}
      <section className="home-mission-section">
        <div className="home-mission-main-content">
          <div className="home-mission-left-content">
            <p className="home-mission-why-choose-us">Why Choose Us?</p>
            <h2 className="home-mission-our-mission">Our Mission</h2>
            <p className="home-mission-description">
              At Raysol Solar Tech Private Limited, our mission is to make renewable energy
              accessible and affordable for everyone. We are dedicated to
              developing innovative solar solutions that not only save you
              money but also contribute to a healthier planet.
            </p>
           {/* Reusing existing button style */}
           <button
              className="home-explore-now-btn"
              onClick={handleExploreNow}
               >
            Explore Now
           </button>

            {/* These taglines were in a separate wrapper in the previous CSS, but here they are directly in the left content.
                If you want them side-by-side on desktop, they need a flex container. For now, they'll stack. */}
            <p className="home-mission-brand-tagline">Trusted by Leading Brands<br/>Powering the Future of Sustainability</p>
          </div>
          <div className="home-mission-right-content">
            {/* Solar Panel Image */}
            <img
              src={MissionImage}
              alt="Solar Panels"
              className="home-mission-image"
              onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/2c3e50/ffffff?text=Image+Not+Found'; }}
            />
          </div>
        </div>
      </section>
      {/* --- End of Our Mission Section --- */}

      {/* --- New: Our Expertise Section --- */}
      <section className="home-expertise-section">
        <div className="home-expertise-main-content">
          <div className="home-expertise-left-content">
            <p className="home-expertise-about-us">About Us</p>
            <h2 className="home-expertise-discover-power">Discover the Power<br/> of Solar</h2>
            <p className="home-expertise-description">
              At Raysol Tech Private Limited, we are committed to revolutionizing the
              way the world uses energy. Our team of experts is dedicated
              to designing and implementing cutting-edge solar solutions
            </p>
            <div className="home-expertise-buttons">
              <button
               className="home-expertise-get-quote-btn"
               onClick={() => {
               document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
                }}
                >
                 Get a Quote
              </button>
             <button
               className="home-expertise-learn-more-btn"
               onClick={() => {
               navigate("/about-info");
               window.scrollTo(0, 0); // Top par scroll karega
               }}
               >
             Learn More
            </button>
            </div>
            <h2 className="home-expertise-our-expertise-heading">Our Expertise</h2>
            <p className="home-expertise-expertise-description">
              With years of industry experience<br/>
              and a deep understanding of the<br/>
              latest solar technologies
            </p>
          </div>
          <div className="home-expertise-right-content">
            <img
              src={ExpertiseImage}
              alt="Solar power illustration"
              className="home-expertise-image"
              onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/2c3e50/ffffff?text=Image+Not+Found'; }}
            />
          </div>
        </div>
      </section>
      {/* --- End of Our Expertise Section --- */}
      {/* --- NEW: Our Services Section (As per Screenshot 2025-07-25 142938.png) --- */}
        <section className="home-our-services-section" id="home-our-services-section">
         <h2 className="home-our-services-heading">Our Services</h2>
         <p className="home-our-services-description">
           From residential to commercial applications, we offer a wide range of solar energy
            <br/>services to help you transition to a sustainable future
         </p>
        <div className="home-our-services-cards-container">
         {/* Service Card 1 */}
          <div className="home-service-card">
          <img
           src={ServiceCardOneImage}
           alt="Residential Solar Solutions"
           className="home-service-card-image"
           onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/300x200/4CAF50/ffffff?text=Residential'; }}
            />
             <button 
              className="home-service-card-button" 
              onClick={() => navigate("/residential-solar")}
               >
              Residential Solar
           </button>
         </div>

       {/* Service Card 2 */}
       <div className="home-service-card">
        <img
        src={ServiceCardTwoImage}
        alt="Commercial Solar Projects"
        className="home-service-card-image"
        onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/300x200/4CAF50/ffffff?text=Commercial'; }}
        />
         <button className="home-service-card-button"
          onClick={() => navigate("/commercial-solar")} // ✅ Route path
           >
          Commercial Solar
        </button>
        </div>

             {/* Service Card 3 */}
            <div className="home-service-card">
             <img
                    src={ServiceCardThreeImage}
                    alt="Solar Maintenance Services"
                   className="home-service-card-image"
                   onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/300x200/4CAF50/ffffff?text=Maintenance'; }}
                 />
                <button className="home-service-card-button">Solar Maintenance</button>
             </div>
         </div>
         </section>
    {/* --- End of NEW: Our Services section --- */}
  <section className="our-partners-section-single-card"> {/* Changed class name */}
   
      <h2 className="our-partners-heading">Our Partners</h2> {/* Reuse heading style */}
      <p className="our-partners-description"> {/* Reuse description style */}
        We are proud to partner with industry-leading brands that share our
        commitment to sustainability and innovation.
      </p>

      <div className="home-single-horizontal-card-container"> {/* Reusing this container */}
        <div className="home-single-horizontal-card"> {/* Reusing this card structure */}
        
          <img src={PartnerImage} alt="Panasonic Solar Panels" className="home-single-horizontal-card-image" />
        </div>
      </div>
    </section>
    {/*----End of New: Our Partner section}
      {/*----End of New: Our Partner section*/}

      {/* --- NEW: Ready to Go Solar? Section (Add this block) --- */}
     <section className="ready-to-go-solar-section" id="contact-us-section">
    <div className="ready-to-solar-content"> {/* NEW: Group heading, description, and button */}
        <h2 className="ready-to-go-solar-heading">Ready to Go Solar? 
         <img
                src={solarPanGif}
                alt="Animated Solar Pan Character"
                className="solar-pan-character-gif"
            /></h2>
        <p className="ready-to-go-solar-description">
            Contact us today to schedule a free consultation and find out how you can start saving with solar energy. 
        </p>
        <button className="ready-to-go-solar-button">Contact Us</button>
    </div>
</section>
      {/* --- End of Ready to Go Solar? Section --- */}
{/* --- NEW: Contact Us Section (Added below "Ready to Go Solar?") --- */}
            <section className="contact-us-section" id="contact">
                <div className="contact-us-container">
                    <h2 className="contact-us-title">Contact Us</h2>
                    <div className="contact-us-content-wrapper">
                        <div className="contact-us-form-column">
                            <form onSubmit={handleSubmit} className="contact-us-form">
                                <div className="form-group-inline">
                                    <div className="form-field">
                                        <label htmlFor="name" className="form-label" placeholder="Enter your full name">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            placeholder="Your Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="form-input"
                                        />
                                    </div><br/>
                                    <div className="form-field">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            placeholder="Your Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="form-input"
                                        />
                                    </div>
                                </div>
                                <div className="form-field">
                                    <label htmlFor="message" className="form-label">Message</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        placeholder="Your Message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        rows="5"
                                        required
                                        className="form-textarea"
                                    ></textarea>
                                </div>
                                <button type="submit" className="contact-us-send-button">Send Message</button>
                            </form>
                        </div>
                        <div className="contact-us-info-column">
                            <h3 className="contact-us-info-heading">Get in Touch</h3>
                            <ul className="contact-us-details-list">
                                <li>
                                    <span className="contact-us-icon">
                                        {/* Location Icon */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"></path><circle cx="12" cy="9" r="3"></circle></svg>
                                    </span>
                                    <span className="contact-us-detail-text">
                                        Main Office: HN2136 Fekri, Jalgaon, Maharashtra - 425001
                                    </span>
                                </li>
                                <li>
                                    <span className="contact-us-icon">
                                        {/* Phone Icon */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92V21a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.18a2 2 0 0 1 1.95 1.5l.63 1.25a2 2 0 0 0 1.95 1.5h6.36a2 2 0 0 0 1.95-1.5l.63-1.25a2 2 0 0 1 1.95-1.5H20a2 2 0 0 1 2 2v13.92z"></path></svg>
                                    </span>
                                    <span className="contact-us-detail-text">
                                        Tel: +91 9307345916
                                    </span>
                                </li>
                                <li>
                                    <span className="contact-us-icon">
                                        {/* Location Icon (for Branch 1) */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"></path><circle cx="12" cy="9" r="3"></circle></svg>
                                    </span>
                                    <span className="contact-us-detail-text">
                                        Branch 1: T-04, Plot 154, Indrapuri C Sector, Bhopal, MP - 402629
                                    </span>
                                </li>
                                <li>
                                    <span className="contact-us-icon">
                                        {/* Phone Icon (for Branch 1) */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92V21a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.18a2 2 0 0 1 1.95 1.5l.63 1.25a2 2 0 0 0 1.95 1.5h6.36a2 2 0 0 0 1.95-1.5l.63-1.25a2 2 0 0 1 1.95-1.5H20a2 2 0 0 1 2 2v13.92z"></path></svg>
                                    </span>
                                    <span className="contact-us-detail-text">
                                        Tel: +91 755393232 (MP) – Pankaj Pawar
                                    </span>
                                </li>
                                <li>
                                    <span className="contact-us-icon">
                                        {/* Email Icon */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                    </span>
                                    <span className="contact-us-detail-text">
                                        Email: info@raysol.in
                                    </span>
                                </li>
                                <li>
                                    <span className="contact-us-icon">
                                        {/* Clock Icon */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                    </span>
                                    <span className="contact-us-detail-text">
                                        Hours: Mon - Sat: 9am - 6pm
                                    </span>
                                </li>
                                <li>
                                    <span className="contact-us-icon">
                                        {/* Globe/Website Icon */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                                    </span>
                                    <span className="contact-us-detail-text">
                                        Website: www.raysol.in
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* --- End of Contact Us Section --- */}

    </>
  );
}
export default Home;
